package com.example.mystybag.appCore.logic.pages

import com.example.mystybag.appCore.model.LanguageSelectionBottomSheetUIState
import com.example.mystybag.common.logic.BSNavigatorLanguageSelection
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel

class LanguageSelectionBottomSheetViewModel(
    context: AppContext,
    private val config: BSNavigatorLanguageSelection
) : ChildViewModel<LanguageSelectionBottomSheetUIState>(
    context = context,
    uiData = LanguageSelectionBottomSheetUIState(currentLanguageCode = config.currentLanguageCode)
) {

    fun onLanguageSelected(code: String) {
        config.onLanguageSelected(code)
    }
}
